import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AudioPlayerService }  from './../../services/audio-player.service';

@Component({
    selector: 'activity-question',
    templateUrl: './activity-question.template.html',
    styleUrls: ['./activity-question.style.scss'],
    standalone: false
})
export class ActivityQuestion implements OnInit, AfterViewInit, OnDestroy {
    @Input() activityInfo: any;
    @Input('productMeta') productMeta : any;
    @Input() contentType: 'pskill' | 'cup-collab-task' = 'pskill';
    public audioPromptId = 'audioPromptId';
    isHelpMessageVisible: boolean = false; // To show hide help block on click of help icon

    constructor(
        private audioPlayerService: AudioPlayerService
    ) { }

    ngOnInit() {
        this.audioPromptId += ('-' + this.contentType);
    }

    ngAfterViewInit() {
        if(this.activityInfo.prompt && this.activityInfo.prompt.type==='audio') {
            const options = {
                rewindButtonId: ('audioPromptRewind-' + this.contentType),
                forwardButtonId: ('audioPromptForward-' + this.contentType),
                playPauseButtonId: ('audioPromptPlayPause-' + this.contentType)
            }
            this.audioPlayerService.createPlayer('#' + this.audioPromptId, options);
        }
    }

    ngOnDestroy() {
        if(this.activityInfo.prompt && this.activityInfo.prompt.type==='audio' ) {
            this.audioPlayerService.destroyPlayer();
        }
    }
}

